import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import {
  getCustomers,
  getCustomerDetail,
  createCustomer,
  updateCustomer,
  deleteCustomer
} from '@/service/orderTest'

// ==================== 模拟数据 ====================

// 模拟客户数据
const mockCustomers = [
  {
    id: 1,
    name: '张小明',
    phone: '13800138000',
    address: '广州市天河区天河路123号',
    points: [116.397470, 39.908823], // [经度, 纬度]
    tags: ['VIP', '旧'],
    channel: 'xiaohongshu',
    createdBy: '张伟',
    preferences: {
      favoriteFood: '喜欢清淡的粤菜，特别偏爱白切鸡和蒸鱼，不喜欢辛辣食物',
      personality: '性格温和，待人友善，比较注重细节，喜欢安静的环境',
      hobbies: '喜欢阅读、听音乐，偶尔会做瑜伽，对养生比较关注'
    },
    storeId: 16,
    storeName: '广州市金宝宝月子中心',
    createTime: '2024-01-01 10:00:00',
    updateTime: '2024-01-15 10:00:00'
  },
  {
    id: 2,
    name: '李小红',
    phone: '13800138001',
    address: '广州市越秀区中山路456号',
    points: [116.407470, 39.918823],
    tags: ['新'],
    channel: 'douyin',
    createdBy: '李明',
    preferences: {
      favoriteFood: '喜欢川菜和湘菜，口味偏重，喜欢吃火锅和麻辣烫',
      personality: '性格开朗活泼，喜欢与人交流，比较健谈，容易相处',
      hobbies: '喜欢逛街购物、看电影，周末喜欢和朋友聚会，热爱美食'
    },
    storeId: 16,
    storeName: '广州市金宝宝月子中心',
    createTime: '2024-01-02 11:00:00',
    updateTime: '2024-01-16 11:00:00'
  },
  {
    id: 3,
    name: '王小华',
    phone: '13800138002',
    address: '广州市海珠区新港路789号',
    points: [116.417470, 39.928823],
    tags: ['VIP'],
    channel: 'xiaohongshu',
    createdBy: '王芳',
    preferences: {
      favoriteFood: '喜欢日式料理和西餐，对食材新鲜度要求较高，偏好清淡口味',
      personality: '性格文静内敛，做事认真负责，比较注重隐私，不太喜欢热闹',
      hobbies: '喜欢摄影、旅行，热爱艺术和设计，喜欢收集手工艺品'
    },
    storeId: 16,
    storeName: '广州市金宝宝月子中心',
    createTime: '2024-01-03 12:00:00',
    updateTime: '2024-01-17 12:00:00'
  },
  {
    id: 4,
    name: '赵小丽',
    phone: '13800138003',
    address: '广州市白云区白云大道101号',
    points: [116.427470, 39.938823],
    tags: ['旧'],
    channel: 'weixin',
    createdBy: '赵敏',
    preferences: {
      favoriteFood: '喜欢家常菜，特别是妈妈做的菜，偏好营养搭配均衡的饮食',
      personality: '性格朴实真诚，待人热情，比较传统，重视家庭观念',
      hobbies: '喜欢做手工、编织，喜欢看电视剧，周末喜欢在家陪伴家人'
    },
    storeId: 16,
    storeName: '广州市金宝宝月子中心',
    createTime: '2024-01-04 13:00:00',
    updateTime: '2024-01-18 13:00:00'
  },
  {
    id: 5,
    name: '钱小强',
    phone: '13800138004',
    address: '广州市番禺区市桥路202号',
    points: [116.437470, 39.948823],
    tags: ['VIP', '新'],
    channel: 'douyin',
    createdBy: '钱磊',
    preferences: {
      favoriteFood: '喜欢海鲜和粤式点心，对美食有较高要求，喜欢尝试新菜品',
      personality: '性格外向自信，做事果断，比较有主见，喜欢追求品质生活',
      hobbies: '喜欢健身运动、打羽毛球，喜欢旅游，对时尚和美容比较关注'
    },
    storeId: 16,
    storeName: '广州市金宝宝月子中心',
    createTime: '2024-01-05 14:00:00',
    updateTime: '2024-01-19 14:00:00'
  },
  {
    id: 6,
    name: '孙小美',
    phone: '13800138005',
    address: '广州市荔湾区荔湾路303号',
    points: [116.447470, 39.958823],
    tags: ['旧'],
    channel: 'xiaohongshu',
    createdBy: '孙丽',
    preferences: {
      favoriteFood: '喜欢素食和有机食品，注重健康饮食，偏好清淡少油的食物',
      personality: '性格温和善良，有爱心，比较细心体贴，喜欢帮助他人',
      hobbies: '喜欢养花种草、做瑜伽，喜欢听轻音乐，对传统文化感兴趣'
    },
    storeId: 16,
    storeName: '广州市金宝宝月子中心',
    createTime: '2024-01-06 15:00:00',
    updateTime: '2024-01-20 15:00:00'
  },
  {
    id: 7,
    name: '周小刚',
    phone: '13800138006',
    address: '广州市黄埔区黄埔大道404号',
    points: [116.457470, 39.968823],
    tags: ['VIP'],
    channel: 'douyin',
    createdBy: '周静',
    preferences: {
      favoriteFood: '喜欢东北菜和烧烤，口味偏重，喜欢吃肉，不太喜欢甜食',
      personality: '性格豪爽直率，说话直接，比较务实，做事雷厉风行',
      hobbies: '喜欢打篮球、看球赛，喜欢和朋友聚餐，对汽车比较感兴趣'
    },
    storeId: 16,
    storeName: '广州市金宝宝月子中心',
    createTime: '2024-01-07 16:00:00',
    updateTime: '2024-01-21 16:00:00'
  },
  {
    id: 8,
    name: '吴小芳',
    phone: '13800138007',
    address: '广州市花都区花都大道505号',
    points: [116.467470, 39.978823],
    tags: ['新', '旧'],
    channel: 'weixin',
    createdBy: '吴强',
    preferences: {
      favoriteFood: '喜欢甜品和下午茶，偏好精致的点心，对咖啡和茶有研究',
      personality: '性格优雅知性，比较有品味，喜欢精致的生活，注重生活品质',
      hobbies: '喜欢品茶、阅读、写书法，喜欢看艺术展，对古典音乐有研究'
    },
    storeId: 16,
    storeName: '广州市金宝宝月子中心',
    createTime: '2024-01-08 17:00:00',
    updateTime: '2024-01-22 17:00:00'
  }
]

// ==================== 初始状态 ====================

const initialState = {
  // 客户列表状态
  list: {
    fetching: false,
    error: null,
    query: {},
    data: {
      list: [],
      total: 0,
      pageNumber: 1,
      pageSize: 20
    }
  },
  // 客户详情状态
  detail: {
    fetching: false,
    error: null,
    data: null
  },
  // 创建客户操作
  create: {
    fetching: false,
    error: null
  },
  // 更新客户操作
  update: {
    fetching: false,
    error: null
  },
  // 删除客户操作
  delete: {
    fetching: false,
    error: null
  }
}

// ==================== 异步Action ====================

/**
 * 异步获取客户列表的thunk action
 * @param {Object} query - 查询参数对象
 * @returns {Promise} 返回处理后的API响应数据
 */
export const fetchCustomers = createAsyncThunk(
  'customer/fetchCustomers',
  async (query = {}, { rejectWithValue }) => {
    try {
      // TODO: 对接真实API
      // const response = await getCustomers(query)
      // return {
      //   data: response.data,
      //   query
      // }
      
      // 模拟API响应
      return new Promise((resolve) => {
        setTimeout(() => {
          let filteredCustomers = [...mockCustomers]
          
          // 根据关键词搜索（姓名或手机号）
          if (query.keyword) {
            const keyword = query.keyword.toLowerCase()
            filteredCustomers = filteredCustomers.filter(customer => 
              customer.name.toLowerCase().includes(keyword) ||
              customer.phone.includes(keyword)
            )
          }
          
          // 根据标签筛选
          if (query.tags) {
            const tags = Array.isArray(query.tags) ? query.tags : [query.tags]
            filteredCustomers = filteredCustomers.filter(customer => {
              if (!customer.tags || customer.tags.length === 0) return false
              return tags.some(tag => customer.tags.includes(tag))
            })
          }
          
          // 根据门店ID筛选
          if (query.storeId) {
            filteredCustomers = filteredCustomers.filter(customer => 
              String(customer.storeId) === String(query.storeId)
            )
          }
          
          // 根据渠道筛选
          if (query.channel) {
            filteredCustomers = filteredCustomers.filter(customer => 
              String(customer.channel) === String(query.channel)
            )
          }
          
          // 根据时间范围筛选
          if (query.startTime) {
            filteredCustomers = filteredCustomers.filter(customer => 
              customer.createTime >= query.startTime
            )
          }
          if (query.endTime) {
            filteredCustomers = filteredCustomers.filter(customer => 
              customer.createTime <= query.endTime
            )
          }
          
          // 分页处理
          const page = query.page || 1
          const pageSize = query.pageSize || 20
          const start = (page - 1) * pageSize
          const end = start + pageSize
          const paginatedCustomers = filteredCustomers.slice(start, end)
          
          resolve({
            data: {
              list: paginatedCustomers,
              total: filteredCustomers.length,
              pageNumber: page,
              pageSize: pageSize
            },
        query
          })
        }, 300) // 模拟网络延迟
      })
    } catch (error) {
      return rejectWithValue(error.response?.data || '获取客户列表失败')
    }
  }
)

/**
 * 异步获取客户详情的thunk action
 * @param {string|number} customerId - 客户ID
 * @returns {Promise} 返回处理后的API响应数据
 */
export const fetchCustomerDetail = createAsyncThunk(
  'customer/fetchCustomerDetail',
  async (customerId, { rejectWithValue }) => {
    try {
      // TODO: 对接真实API
      // const response = await getCustomerDetail(customerId)
      // return {
      //   data: response.data
      // }
      
      // 模拟API响应
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          const customer = mockCustomers.find(c => String(c.id) === String(customerId))
          if (customer) {
            // 添加服务历史记录和相关跟进人资料（模拟数据）
            const customerDetail = {
              ...customer,
              orderHistory: [
                {
                  id: 1,
                  orderNo: 'ORD20240101001',
                  serviceType: 'maternity',
                  serviceTypeName: '产康',
                  status: 'completed',
                  statusName: '已完成',
                  amount: 12800.00,
                  createTime: '2024-01-01 10:00:00',
                  startTime: '2024-01-01 10:00:00',
                  endTime: '2024-01-15 10:00:00'
                },
                {
                  id: 2,
                  orderNo: 'ORD20240102002',
                  serviceType: 'nursing',
                  serviceTypeName: '护理',
                  status: 'in_progress',
                  statusName: '进行中',
                  amount: 15800.00,
                  createTime: '2024-01-02 11:00:00',
                  startTime: '2024-01-02 11:00:00',
                  endTime: '2024-01-20 11:00:00'
                }
              ],
              followUpStaff: [
                {
                  id: 1,
                  name: '陈美玲',
                  phone: '13900139001',
                  position: '客户经理',
                  department: '销售部',
                  remark: '主要负责客户维护和跟进'
                },
                {
                  id: 2,
                  name: '刘建国',
                  phone: '13900139002',
                  position: '服务顾问',
                  department: '服务部',
                  remark: '负责客户服务咨询'
                }
              ]
            }
            resolve({
              data: customerDetail
            })
          } else {
            reject({ response: { data: '客户不存在' } })
          }
        }, 200)
      })
    } catch (error) {
      return rejectWithValue(error.response?.data || '获取客户详情失败')
    }
  }
)

/**
 * 异步创建客户的thunk action
 * @param {Object} data - 客户数据
 * @returns {Promise} 返回处理后的API响应数据
 */
export const createCustomerAction = createAsyncThunk(
  'customer/createCustomer',
  async (data, { rejectWithValue }) => {
    try {
      // TODO: 对接真实API
      // const response = await createCustomer(data)
      // return {
      //   data: response.data
      // }
      
      // 模拟API响应
      return new Promise((resolve) => {
        setTimeout(() => {
          const newCustomer = {
            id: mockCustomers.length > 0 ? Math.max(...mockCustomers.map(c => c.id)) + 1 : 1,
            ...data,
            storeId: data.storeId || 16,
            storeName: data.storeName || '广州市金宝宝月子中心',
            createTime: new Date().toLocaleString('zh-CN', { 
              year: 'numeric', 
              month: '2-digit', 
              day: '2-digit', 
              hour: '2-digit', 
              minute: '2-digit', 
              second: '2-digit',
              hour12: false
            }).replace(/\//g, '-'),
            updateTime: new Date().toLocaleString('zh-CN', { 
              year: 'numeric', 
              month: '2-digit', 
              day: '2-digit', 
              hour: '2-digit', 
              minute: '2-digit', 
              second: '2-digit',
              hour12: false
            }).replace(/\//g, '-')
          }
          mockCustomers.push(newCustomer)
          resolve({
            data: newCustomer
          })
        }, 300)
      })
    } catch (error) {
      return rejectWithValue(error.response?.data || '创建客户失败')
    }
  }
)

/**
 * 异步更新客户的thunk action
 * @param {Object} params - 参数对象
 * @param {string|number} params.customerId - 客户ID
 * @param {Object} params.data - 更新数据
 * @returns {Promise} 返回处理后的API响应数据
 */
export const updateCustomerAction = createAsyncThunk(
  'customer/updateCustomer',
  async ({ customerId, data }, { rejectWithValue }) => {
    try {
      // TODO: 对接真实API
      // const response = await updateCustomer(customerId, data)
      // return {
      //   data: response.data,
      //   customerId
      // }
      
      // 模拟API响应
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          const customerIndex = mockCustomers.findIndex(c => String(c.id) === String(customerId))
          if (customerIndex !== -1) {
            mockCustomers[customerIndex] = {
              ...mockCustomers[customerIndex],
              ...data,
              updateTime: new Date().toLocaleString('zh-CN', { 
                year: 'numeric', 
                month: '2-digit', 
                day: '2-digit', 
                hour: '2-digit', 
                minute: '2-digit', 
                second: '2-digit',
                hour12: false
              }).replace(/\//g, '-')
            }
            resolve({
              data: mockCustomers[customerIndex],
        customerId
            })
          } else {
            reject({ response: { data: '客户不存在' } })
      }
        }, 300)
      })
    } catch (error) {
      return rejectWithValue(error.response?.data || '更新客户失败')
    }
  }
)

/**
 * 异步删除客户的thunk action
 * @param {string|number} customerId - 客户ID
 * @returns {Promise} 返回处理后的API响应数据
 */
export const deleteCustomerAction = createAsyncThunk(
  'customer/deleteCustomer',
  async (customerId, { rejectWithValue }) => {
    try {
      // TODO: 对接真实API
      // const response = await deleteCustomer(customerId)
      // return {
      //   data: response.data,
      //   customerId
      // }
      
      // 模拟API响应（软删除，标记为已删除状态）
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          const customerIndex = mockCustomers.findIndex(c => String(c.id) === String(customerId))
          if (customerIndex !== -1) {
            // 软删除：从列表中移除
            mockCustomers.splice(customerIndex, 1)
            resolve({
              data: { success: true, message: '删除成功' },
        customerId
            })
          } else {
            reject({ response: { data: '客户不存在' } })
      }
        }, 300)
      })
    } catch (error) {
      return rejectWithValue(error.response?.data || '删除客户失败')
    }
  }
)

// ==================== Redux Slice ====================

const customerSlice = createSlice({
  name: 'customer',
  initialState,
  reducers: {
    /**
     * 重置客户列表状态
     */
    resetCustomerListState: (state) => {
      state.list = {
        fetching: false,
        error: null,
        query: {},
        data: {
          list: [],
          total: 0,
          pageNumber: 1,
          pageSize: 20
        }
      }
    },
    /**
     * 重置客户详情状态
     */
    resetCustomerDetailState: (state) => {
      state.detail = {
        fetching: false,
        error: null,
        data: null
      }
    },
    /**
     * 重置创建客户操作
     */
    resetCreateState: (state) => {
      state.create = {
        fetching: false,
        error: null
      }
    },
    /**
     * 重置更新客户操作
     */
    resetUpdateState: (state) => {
      state.update = {
        fetching: false,
        error: null
      }
    },
    /**
     * 重置删除客户操作
     */
    resetDeleteState: (state) => {
      state.delete = {
        fetching: false,
        error: null
      }
    }
  },
  extraReducers: (builder) => {
    builder
      // ========== 获取客户列表 ==========
      .addCase(fetchCustomers.pending, (state) => {
        state.list.fetching = true
        state.list.error = null
      })
      .addCase(fetchCustomers.fulfilled, (state, action) => {
        state.list.fetching = false
        state.list.error = null
        state.list.query = action.payload.query || {}
        state.list.data = action.payload.data || {
          list: [],
          total: 0,
          pageNumber: 1,
          pageSize: 20
        }
      })
      .addCase(fetchCustomers.rejected, (state, action) => {
        state.list.fetching = false
        state.list.error = action.payload
        state.list.data = {
          list: [],
          total: 0,
          pageNumber: 1,
          pageSize: 20
        }
      })
      // ========== 获取客户详情 ==========
      .addCase(fetchCustomerDetail.pending, (state) => {
        state.detail.fetching = true
        state.detail.error = null
      })
      .addCase(fetchCustomerDetail.fulfilled, (state, action) => {
        state.detail.fetching = false
        state.detail.error = null
        state.detail.data = action.payload.data
      })
      .addCase(fetchCustomerDetail.rejected, (state, action) => {
        state.detail.fetching = false
        state.detail.error = action.payload
        state.detail.data = null
      })
      // ========== 创建客户 ==========
      .addCase(createCustomerAction.pending, (state) => {
        state.create.fetching = true
        state.create.error = null
      })
      .addCase(createCustomerAction.fulfilled, (state) => {
        state.create.fetching = false
        state.create.error = null
      })
      .addCase(createCustomerAction.rejected, (state, action) => {
        state.create.fetching = false
        state.create.error = action.payload
      })
      // ========== 更新客户 ==========
      .addCase(updateCustomerAction.pending, (state) => {
        state.update.fetching = true
        state.update.error = null
      })
      .addCase(updateCustomerAction.fulfilled, (state, action) => {
        state.update.fetching = false
        state.update.error = null
        // 如果列表中有该客户，更新其数据
        const customerId = action.payload.customerId
        const customer = state.list.data.list.find(item => String(item.id) === String(customerId))
        if (customer && action.payload.data) {
          Object.assign(customer, action.payload.data)
        }
      })
      .addCase(updateCustomerAction.rejected, (state, action) => {
        state.update.fetching = false
        state.update.error = action.payload
      })
      // ========== 删除客户 ==========
      .addCase(deleteCustomerAction.pending, (state) => {
        state.delete.fetching = true
        state.delete.error = null
      })
      .addCase(deleteCustomerAction.fulfilled, (state, action) => {
        state.delete.fetching = false
        state.delete.error = null
        // 从列表中移除该客户
        const customerId = action.payload.customerId
        state.list.data.list = state.list.data.list.filter(item => String(item.id) !== String(customerId))
        state.list.data.total = Math.max(0, state.list.data.total - 1)
      })
      .addCase(deleteCustomerAction.rejected, (state, action) => {
        state.delete.fetching = false
        state.delete.error = action.payload
      })
  }
})

export const {
  resetCustomerListState,
  resetCustomerDetailState,
  resetCreateState,
  resetUpdateState,
  resetDeleteState
} = customerSlice.actions

export default customerSlice.reducer

